import subscribeStore from "common/browser/subscribeStore"
import { init } from "common/services/user/index"

export default function postRender(store) {
  subscribeStore(store)

  store.dispatch(init())
}
